//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { ICommentLike } from "@/interfaces/activityFeedNotifications";

//hooks
import { getCommentLike } from "./CommentLike.service";

//components
import { ActionFeedbackBanner } from "thrive-components";
import UserComment from "../../elements/userComment/UserComment";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import CommentLikeTitle from "../../elements/notificationTitle/CommentLikeTitle/CommentLikeTitle";

//styling
import "../../../../../css/activityFeed/notifications/comment-activity.scss";



const CommentLike = ({ zIndexNum, isPopOut = false, timeStamp, dateStamp, user, comment, commentAuthor, content, appDetails, getOpenOnWebLink, notificationDetails}: ICommentLike) => {
    const {screenClassName, deletedCommentClassName, showDeletedBanner, deletedBannerMessage, truncation, showFeedbackBanner, feedbackType, feedbackMessage, hideMenu, time, date, appImageUrl, appName, contentTitle, contentLink} = getCommentLike({isPopOut, timeStamp, dateStamp, comment, content, appDetails, notificationDetails})

    return (
        <div className={`${isPopOut ? "" : "comment-notification-full"} comment-notification notification-wrapper`} data-testid={"comment-like-user-activity"}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.commentLike} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}                   
                />
                
                <CommentLikeTitle 
                    isPopOut={isPopOut}
                    user={user.name} 
                    commentAuthor={commentAuthor?.name}
                />
            </div>        
            
            <UserComment 
                zIndexNum={zIndexNum} 
                className={`${screenClassName} ${deletedCommentClassName}`} 
                commentText={comment.text} 
                truncateNumber={truncation} 
                getWebLink={getOpenOnWebLink} 
                isReply  
                hideMenu={hideMenu}
            />
            
            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }     

            <DeletedBanner 
                isDeleted={showDeletedBanner} 
                message={deletedBannerMessage}
            />

            <ActivityInformationPanel 
                className={screenClassName} 
                time={time} 
                dateStamp={date}
                appImageUrl={appImageUrl} 
                appName={appName} 
                contentTitle={contentTitle} 
                contentLink={contentLink} 
                isReply={true}
            />
        </div>
    )
};

export default CommentLike